import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MenuResizer } from 'src/app/components/review/browse/menu-resizer';

@Component({
    selector: 'lex-sidenav-container',
    templateUrl: './sidenav-container.component.html',
    styleUrls: ['./sidenav-container.component.scss'],
    standalone: false
})
export class SidenavContainerComponent implements OnInit {
	@Input() defaultNavSize: number = 540;
	menuResizer: MenuResizer = new MenuResizer({ menuWidth: 540 });
	sideNavContentSize: number;

	ngOnInit(): void {
		this.sideNavContentSize = window.innerWidth - this.defaultNavSize;
	}

	@HostListener('window:mousemove', ['$event'])
	windowMouseMove(event: MouseEvent) {
		this.menuResizer.mouseMove(event);
		this.sideNavContentSize = window.innerWidth - this.menuResizer.menuWidth;
	}

	@HostListener('window:mouseup')
	windowMouseUp() {
		this.menuResizer.mouseUp();
		this.sideNavContentSize = window.innerWidth - this.menuResizer.menuWidth;
	}
}
